// == Import npm
import React, { useEffect, useState } from "react";
import { Modal, Steps } from "antd";

// == Import SCSS
import "./modalPrint.less";

// == Import icons

// == Import components
import Badge from "./Badge/Badge";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";

const { Step } = Steps;

const ModalPrint = ({
  isVisible,
  setVisible,
  visitorCheck,
  setSearch,
  setVisitorCheck,
  mustCheckIn = false,
  disablePrinter = false,
  useKeyCard,
  limitToRegister = false,
}) => {
  const [isVerifyIdentityDisplayed, setVerifyIdentityDisplayed] = useState(true);
  const [isDisabled, setDisabled] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (location?.state?.type === "resident") setVerifyIdentityDisplayed(false);
  }, [location]);

  const handleOk = () => {
    setVisible(false);
    setVerifyIdentityDisplayed(true);
    setDisabled(true);
  };

  const handleCancel = () => {
    setVisible(false);
    setVerifyIdentityDisplayed(true);
    setDisabled(true);
  };

  const [current, setCurrent] = React.useState(0);

  return (
    <div>
      <Modal
        width="700px"
        open={isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        bodyStyle={{ padding: "24px 0" }}
      >
        {visitorCheck.length === 1 ? null : (
          <Steps current={current} labelPlacement="vertical" progressDot={true}>
            {visitorCheck.map((visitor, index) => (
              <Step key={visitor.id} title={`${visitor.lastname}`} />
            ))}
          </Steps>
        )}

        <div>
          {visitorCheck[current] !== undefined && (
            <Badge
              visitor={visitorCheck[current]}
              visitorCheck={visitorCheck}
              currentUser={current}
              setCurrent={setCurrent}
              setVisible={setVisible}
              setSearch={setSearch}
              setVisitorCheck={setVisitorCheck}
              verifyIdentityDisplayed={isVerifyIdentityDisplayed}
              setVerifyIdentityDisplayed={setVerifyIdentityDisplayed}
              setDisabled={setDisabled}
              isDisabled={isDisabled}
              mustCheckIn={mustCheckIn}
              disablePrinter={disablePrinter}
              useKeyCard={useKeyCard}
              limitToRegister={limitToRegister}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ModalPrint;
